import { useQueryClient } from "react-query";
import { useMutation } from "react-query";
import { notification } from "antd";
import { isError } from "utils/api/models/api-response";
import { DeleteServiceAsync } from "services/Services";
import i18next from "i18next";

export default function DeleteService() {
  const queryClient = useQueryClient();
  return {
    ...useMutation(DeleteServiceAsync, {
      onSuccess: async (res) => {
        if (!isError(res)) {
          notification.open({
            message:
              i18next.language === "ar"
                ? "تم حذف الخدمة بنجاح"
                : "Service has been deleted successfully",
          });
          queryClient.invalidateQueries("services-by-category");
          queryClient.invalidateQueries("services-by-level");
        }
      },
    }),
  };
}
